import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RpTable, { Loading } from 'rp-react-table';
import axios from 'axios';
import columns from './columns';
import Select from '../../shared/Select';
import { formatDate, sortByDate } from '../../utils/date';
import transformData from './transformData';

const travelersCheckTable = 'travelersCheck';
const tableKeys = ['travelersCheck', 'firstTimeBlinkers', 'sevenDayWinners'];
const tableHeaders = ['Travellers\' Check', 'First Time Blinkers', 'Seven-Day Winners'];

class Signposts extends PureComponent {
    constructor(props) {
        super(props);

        const dates = (props.data.upcomingRaces || [])
            .sort(sortByDate('raceDate', true))
            .map(item => item.raceDate);
        this.state = {
            signposts: props.data.signposts,
            optionDates: dates.map(date => formatDate(date, 'dddd, DD MMM Y')),
            urlDates: dates.map(date => formatDate(date, 'Y-MM-DD')),
            selectValue: 0,
            loading: false,
        };
    }

    onSelect = (val) => {
        if (this.state.selectValue === +val) { return; }
        this.fetchData(+val);
    };

    fetchData(selectValue) {
        this.setState({ selectValue, loading: true });

        const { id } = this.props.params;
        const urlDate = this.state.urlDates[selectValue];
        axios.get(`course/filter/signposts/${id}/${urlDate}`)
            .then(({ data }) => {
                this.setState({
                    loading: false,
                    signposts: data.signposts,
                });
            })
            .catch(error => console.warn(error));
    }

    render() {
        const { signposts, optionDates, loading, selectValue } = this.state;
        const { params } = this.props;
        const transSignposts = transformData(signposts, params);
        const transformTravelersCheck = transSignposts.travelersCheck.map((post) => {
            const updatedPost = { ...post };
            if (post.miles === 0 && isNaN(parseFloat(post.distOut))) {
                updatedPost.miles = post.distOut;
            }

            return updatedPost;
        });

        const transformSignpostData = {
            ...transSignposts,
            travelersCheck: transformTravelersCheck,
        };

        return (
            <section className="cp-signposts">
                {optionDates.length > 1 &&
                    <div className="cp-signposts__dropdown">
                        <strong>Meeting</strong>
                        <Select
                            value={selectValue}
                            options={optionDates}
                            onSelect={this.onSelect}
                        />
                    </div>
                }
                {loading ? <Loading /> : tableKeys.map((key, i) => (
                    <div key={key} className={`cp-signposts__${key}`}>
                        <h3>{tableHeaders[i]}</h3>
                        <RpTable
                            columns={columns[key]}
                            data={transformSignpostData[key]}
                            sortable={key === travelersCheckTable}
                            initialSortIdx={key === travelersCheckTable ? 3 : 1}
                            noDataText={`No ${tableHeaders[i]} data available
                                for this meeting in the Racing Post database`}
                        />
                    </div>
                ))}
            </section>
        );
    }
}

const columnPropsShape = {
    horseStyleName: PropTypes.string,
    horseUid: PropTypes.number,
    raceDatetime: PropTypes.string,
};

Signposts.propTypes = {
    data: PropTypes.shape({
        signposts: PropTypes.shape({
            travelersCheck: PropTypes.arrayOf(PropTypes.shape({
                ...columnPropsShape,
                trainerStyleName: PropTypes.string,
                trainerUid: PropTypes.number,
            })),
            firstTimeBlinkers: PropTypes.arrayOf(PropTypes.shape(
                columnPropsShape
            )),
            sevenDayWinners: PropTypes.arrayOf(PropTypes.shape({
                ...columnPropsShape,
                courseStyleName: PropTypes.string,
                courseUid: PropTypes.number,
                raceInstanceTitle: PropTypes.string,
                raceInstanceUid: PropTypes.number,
            })),
        }),
        upcomingRaces: PropTypes.arrayOf(PropTypes.shape({
            raceDate: PropTypes.string.isRequired,
        })),
    }).isRequired,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default Signposts;



// WEBPACK FOOTER //
// ./src/js/course/signposts/Signposts.jsx